module.exports = __webpack_public_path__ + "img/2.3d334cc9.jpg";